import Image from 'next/image'
import { FunctionComponent } from 'react'
import useBrandInfo from '@/hooks/use-brand-info'

interface LogoIconProps {
  width?: number
  height?: number
}

const LogoIcon: FunctionComponent<LogoIconProps> = ({
  width = 32,
  height = 32,
}) => {
  const { appLogoSrc } = useBrandInfo()
  return (
    <Image alt='logo icon' height={height} src={appLogoSrc} width={width} />
  )
}

export default LogoIcon
